export class usersLastestCampaignsReportFilter {
    zone: number;
    userName: string;
    division: number;
    area: number;
}